import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  VivaWalletTerminalAbortResponse,
  VivaWalletTerminalApiService,
} from '@core/services/api/viva-wallet-terminal/viva-wallet-terminal-api.service';

@Injectable({
  providedIn: 'root',
})
export class VivaWalletTerminalService {
  constructor(private readonly vivaWalletTerminalApi: VivaWalletTerminalApiService) {}

  abortTransaction$(orderId: string): Observable<VivaWalletTerminalAbortResponse> {
    return this.vivaWalletTerminalApi.abortTransaction$(orderId);
  }
}
